import { render, staticRenderFns } from "./CopiableLink.vue?vue&type=template&id=4617f066&scoped=true"
import script from "./CopiableLink.vue?vue&type=script&lang=js"
export * from "./CopiableLink.vue?vue&type=script&lang=js"
import style0 from "./CopiableLink.vue?vue&type=style&index=0&id=4617f066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4617f066",
  null
  
)

export default component.exports